import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { REGISTRATION_TEMPLATES } from '@interlayer/js/app/store/reducers/Registration/constants';

export const useIsRetailUpgrade = () => {
    const { config: { registrationForcedType } } = useRegistrationSelector();

    return registrationForcedType === REGISTRATION_TEMPLATES.retailUpgrade;
};
